/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { CheckA2Icon16Light } from './CheckA2Icon16Light';
import { CheckA2Icon16Regular } from './CheckA2Icon16Regular';
import { CheckA2Icon16Solid } from './CheckA2Icon16Solid';
import { CheckA2Icon20Light } from './CheckA2Icon20Light';
import { CheckA2Icon20Regular } from './CheckA2Icon20Regular';
import { CheckA2Icon20Solid } from './CheckA2Icon20Solid';
import { CheckA2Icon24Regular } from './CheckA2Icon24Regular';
import { CheckA2Icon24Solid } from './CheckA2Icon24Solid';
import { CheckA2Icon32Regular } from './CheckA2Icon32Regular';
import { CheckA2Icon64Regular } from './CheckA2Icon64Regular';
var sizes = {
    16: {
        light: CheckA2Icon16Light,
        regular: CheckA2Icon16Regular,
        solid: CheckA2Icon16Solid,
    },
    20: {
        light: CheckA2Icon20Light,
        regular: CheckA2Icon20Regular,
        solid: CheckA2Icon20Solid,
    },
    24: {
        regular: CheckA2Icon24Regular,
        solid: CheckA2Icon24Solid,
    },
    32: {
        regular: CheckA2Icon32Regular,
    },
    64: {
        regular: CheckA2Icon64Regular,
    },
};
export var CheckA2Icon = forwardRef('CheckA2Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
